import React from 'react';
import styled from '@emotion/styled';
import colors, { white } from '../../../../theme/colors';
import DashboardDiscoverModeCrossIcon from '../icons/DashboardDiscoverModeCrossIcon';
import { isDarkMode } from '../../../../utils/helpers';
import breakpoints from '../../../../theme/material/breakpoints';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const ContainerWrapper = styled('div')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    display: 'inline-flex',
    padding: '11px 20px',
    alignItems: 'center',
    gap: 5,
    borderRadius: 15,
    border: `3px solid ${colors[theme].red.primary}`,
    background: white,
    position: 'absolute',
    left: 10,
    top: 30,
    opacity: 0.6,
    [breakpoints.up(769)]: {
      left: 20,
    },
  };
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const PassTextWrapper = styled('div')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    color: colors[theme].red.primary,
    textAlign: 'center',
    fontSize: 22,
    fontStyle: 'normal',
    fontWeight: 700,
    letterSpacing: -0.44,
  };
});

const DashboardDiscoverModePassFlagOverlay: React.FC = () => {
  return (
    <ContainerWrapper>
      <DashboardDiscoverModeCrossIcon />
      <PassTextWrapper>NOPE!</PassTextWrapper>
    </ContainerWrapper>
  );
};

export default DashboardDiscoverModePassFlagOverlay;
